// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2ae726c2","239":"56f21aa6","732":"77a14665"}[chunkId] + ".chunk.js";
};